export default class ScrollTo {

    constructor(elementName, innerElementName, show) {
        this.elementName = elementName;
        this.innerElementName = innerElementName;
        this.show = show;
        return this;
    }

    go() {

        let ratio = 'landscape';
        if (document.body.clientHeight > document.body.clientWidth)
            ratio = 'portrait';
		
        if (ratio == 'landscape')
            this.offset = document.getElementById(this.elementName).offsetTop - (window.innerHeight / 2 - 70)
        else
            this.offset = document.getElementById(this.elementName).offsetTop;
		
		if(!window.portraitMode && window.sdk.isExtended()) {			
			this.offset = document.getElementById(this.elementName).offsetTop;
		}
        //this.element = document.getElementById(this.innerElementName);
		if(!window.portraitMode && window.sdk.isExtended()) 
			this.element = document.querySelector('#' + this.innerElementName + ' .odj');
		else if(window.sdk.isExtended()) {
			this.element = document.getElementById(this.innerElementName);
		}
		else
			this.element = document.getElementById(this.innerElementName);
		
        this.direction = 'top';
        if ((this.offset - this.element.scrollTop) > 0)
            this.direction = 'down';
        this.duration = 300;
        this.interval = 5;
        this.step = (this.duration / this.interval);
        this.distance = Math.abs((this.offset - this.element.scrollTop));
        this.increment = Math.round(this.distance / this.step);
        this.nbIter = 0;
        if (!this.show)
            return;
        this.call = setInterval(() => {
            this.scroll();
            this.nbIter++;
            if (this.nbIter > this.step)
                clearInterval(this.call);
        }, this.interval)
    }

    scroll() {
        if (this.direction == 'down') {
            this.element.scrollTop += this.increment
            if (this.element.scrollTop >= this.offset)
                this.element.scrollTop = this.offset - 1
        }
        else {
            this.element.scrollTop -= this.increment
        }
    }

    remove() {
        if (this.call)
            clearInterval(this.call);
    }
}



// WEBPACK FOOTER //
// ./src/Utils/ScrollTo.js